import { ModelStatus } from '../../../shared/dtos/model-status';
import { createSelectionItem, SelectionItem } from '../../../shared/dtos/selection-item';
import { UnsavedServiceLevelConfiguration } from '../dtos/service-level-config.dto';
import { UnsavedServiceLevelConfigurationModel } from './service-level-configuration.model';

export class UnsavedServiceLevelConfigurationGroup {
    public readonly _newConfigs: {[marketSectorId: string]: UnsavedServiceLevelConfigurationModel} = {};

    public constructor() {}

    public removeUnsavedConfigs(marketSectorId: number): void {
        delete this._newConfigs[marketSectorId];
    }

    public addNewConfig(unsaved: UnsavedServiceLevelConfiguration): void {
        const configs = [...this.getNewConfigs()];
        configs.push(new UnsavedServiceLevelConfigurationModel(unsaved));

        const serviceLevelIds = [...new Set(configs.map(c => c.serviceLevelId))];

        const hasDifferentServiceLevelIds = serviceLevelIds.length > 1;
        if (hasDifferentServiceLevelIds) {
            throw new Error('Service level configurations contains different service levels. Please pass in configurations under the same service level.');
        }
        this._newConfigs[unsaved.marketSectorId] = new UnsavedServiceLevelConfigurationModel(unsaved);
    }

    public getNewConfigs(): UnsavedServiceLevelConfigurationModel[] {
        const result: UnsavedServiceLevelConfigurationModel[] = [];
        Object.keys(this._newConfigs).forEach(marketSectorId => {
            result.push(this._newConfigs[marketSectorId]);
        });
        return result;
    }

    public getNewConfigByMarketSector(marketSectorId: number): UnsavedServiceLevelConfigurationModel {
        return this._newConfigs[marketSectorId];
    }

    public updateConfigDurations(durationIds: number[]): void {
        this.updateSelectionItems('durations', durationIds);
    }

    public updateConfigCoverageLevels(coverageLevelIds: number[]): void {
        this.updateSelectionItems('coverageLevels', coverageLevelIds);
    }

    private updateSelectionItems(name: string, selectionIds: number[]): void {
        const newIds = this.getNewConfigs().map(c => c.marketSectorId);
        newIds.forEach(marketSectorId => {
            const key = name as keyof UnsavedServiceLevelConfigurationModel;
            const config = this.getNewConfigByMarketSector(marketSectorId);
            config.modelStatus = ModelStatus.NEW;
            const newItems = selectionIds.map(id => createSelectionItem(id, '', '', ModelStatus.NEW));
            const originalItems = config[key] as unknown as SelectionItem[];
            originalItems.splice(0, originalItems.length);
            originalItems.push(...newItems);
        });
    }

    public updateServiceLevel(name: string, id: number): void {
        Object.values(this._newConfigs).forEach(item => {
            item.serviceLevelName = name;
            item.serviceLevelId = id;
        });
    }
}
